import { Component, Input, OnInit } from '@angular/core';
import {
  NgbActiveModal,
  NgbDateStruct,
  NgbTimeStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { faClock, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'san-notification-reminder-modal',
  templateUrl: './notification-reminder-modal.component.html',
  styleUrls: ['./notification-reminder-modal.component.scss'],
  standalone: false,
})
export class NotificationReminderModalComponent implements OnInit {
  @Input() notificationTitle: string;

  faClock = faClock;
  faCalendarAlt = faCalendarAlt;

  selectedDate: NgbDateStruct;
  selectedTime: NgbTimeStruct;

  quickOptions = [
    {
      label: 'In 1 Stunde',
      getValue: () => {
        const d = new Date();
        d.setHours(d.getHours() + 1);
        return d;
      },
    },
    {
      label: 'Heute Abend (18:00)',
      getValue: () => {
        const d = new Date();
        d.setHours(18, 0, 0, 0);
        if (d <= new Date()) d.setDate(d.getDate() + 1); // Falls es schon nach 18 Uhr ist, morgen
        return d;
      },
    },
    {
      label: 'Morgen früh (08:00)',
      getValue: () => {
        const d = new Date();
        d.setDate(d.getDate() + 1);
        d.setHours(8, 0, 0, 0);
        return d;
      },
    },
    {
      label: 'In 2 Tagen',
      getValue: () => {
        const d = new Date();
        d.setDate(d.getDate() + 2);
        d.setHours(9, 0, 0, 0);
        return d;
      },
    },
    {
      label: 'Nächste Woche',
      getValue: () => {
        const d = new Date();
        d.setDate(d.getDate() + 7);
        d.setHours(9, 0, 0, 0);
        return d;
      },
    },
  ];

  constructor(public activeModal: NgbActiveModal) {
    const now = new Date();
    this.selectedDate = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate(),
    };
    this.selectedTime = {
      hour: now.getHours(),
      minute: now.getMinutes(),
      second: 0,
    };
  }

  ngOnInit(): void {}

  selectQuickOption(option: { getValue: () => Date }): void {
    const date = option.getValue();
    this.activeModal.close(date);
  }

  saveManual(): void {
    const date = new Date(
      this.selectedDate.year,
      this.selectedDate.month - 1,
      this.selectedDate.day,
      this.selectedTime.hour,
      this.selectedTime.minute,
    );
    this.activeModal.close(date);
  }
}
